import { c as _c } from "react/compiler-runtime";
import { isEmpty } from 'lodash';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserData from 'data-hooks/useUserData';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';
import getNonPDPQueryVariables from './getNonPDPQueryVariables';
const useProductBasicQueryOptions = t0 => {
  const $ = _c(12);
  const {
    id,
    slug,
    queryOptions,
    hookOptions
  } = t0;
  const {
    skipPDPStateHook: t1,
    delayLoad: t2,
    productSku: t3,
    regionId
  } = queryOptions;
  const skipPDPStateHook = t1 === undefined ? false : t1;
  const delayLoad = t2 === undefined ? false : t2;
  const productSku = t3 === undefined ? "" : t3;
  const {
    skip: t4
  } = hookOptions;
  const skip = t4 === undefined ? false : t4;
  const {
    isLoggedIn,
    userId
  } = useUserData();
  const finalNonPDPQueryVariables = skipPDPStateHook ? getNonPDPQueryVariables(id, productSku, hookOptions) : {};
  const userLocation = useUserLocation();
  const locationVars = getVisitorLocationQueryVariables(userLocation?.stateShortName, regionId);
  let t5;
  if ($[0] !== skipPDPStateHook) {
    t5 = {
      skip: skipPDPStateHook
    };
    $[0] = skipPDPStateHook;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    variables,
    skip: skipPdpQuery
  } = usePDPApolloQueryVariables(id, slug, t5);
  const skipPdpVariableQuery = productSku && skipPdpQuery ? false : skipPdpQuery;
  const t6 = skipPDPStateHook ? {
    ...finalNonPDPQueryVariables,
    ...locationVars
  } : {
    ...variables,
    ...locationVars
  };
  const t7 = skip || skipPdpVariableQuery || delayLoad || skipPDPStateHook && isEmpty(finalNonPDPQueryVariables);
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      noBatch: true
    };
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const t9 = queryOptions?.ssr ?? true;
  let t10;
  if ($[3] !== isLoggedIn || $[4] !== queryOptions.fetchPolicy || $[5] !== userId) {
    t10 = isLoggedIn ? {
      fetchPolicy: "cache-and-network",
      queryKey: ["user", userId]
    } : queryOptions.fetchPolicy ? {
      fetchPolicy: queryOptions.fetchPolicy
    } : {};
    $[3] = isLoggedIn;
    $[4] = queryOptions.fetchPolicy;
    $[5] = userId;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== t10 || $[8] !== t6 || $[9] !== t7 || $[10] !== t9) {
    t11 = {
      variables: t6,
      skip: t7,
      context: t8,
      ssr: t9,
      ...t10
    };
    $[7] = t10;
    $[8] = t6;
    $[9] = t7;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
};
export default useProductBasicQueryOptions;